import React, { useState } from 'react';
import { StepButtons } from '../components/StepButtons';
import { Radio } from 'components';
import { withLayout } from 'helpers';

function ConsentButton({ checked, onChange }) {
  return (
    <Radio
      checked={checked}
      name="consent"
      onChange={onChange}
      label={<>I understand</>}
      type="checkbox"
    />
  );
}

function DisclaimerComponent({ history, prevRoute, nextRoute }) {
  const [consented, setConsented] = useState(false);

  return (
    <div className="misc1-container">
      <div className="content">
        <div className="header">
          <StepButtons
            onBack={() => history.push(prevRoute)}
            onNext={() => history.push(nextRoute)}
            disableNext={!consented}
          />
        </div>

        <div className="disclaimer_container">
          <h1 className="important">PLEASE NOTE</h1>
          <p className="par">
            The Nue Reset program is not a compensated clinical trial, it is a
            paid-for healing program which is safe, legal and evidence based.{' '}
          </p>

          <p className="par">
            You will be responsible for an <strong>out-of-pocket</strong> cost
            for this treatment that our experts will discuss with you on your
            discovery call.
          </p>

          <p className="par">
            Please also note that this program is not covered by traditional
            insurance plans.
          </p>

          <ConsentButton
            checked={consented}
            onChange={() => setConsented((v) => !v)}
          />

          <p className="par">
            We provide flexible <strong>payment options</strong> such as HSA/FSA
            spending accounts, third party financing, and accept all major
            credit cards including Discover and AMEX.
          </p>
        </div>
      </div>
    </div>
  );
}

DisclaimerComponent.title = 'Details | Nue Life Questionnaire';

export const DisclaimerScreen = withLayout(DisclaimerComponent);